import { Illustration } from '@react-spectrum/icon';
import React from 'react';
export default function Error404(props) {
  return /*#__PURE__*/React.createElement(Illustration, props, /*#__PURE__*/React.createElement("svg", {
    width: "135.321",
    height: "87"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: "10"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.821 60.5v23a2.006 2.006 0 002 2h118a2.006 2.006 0 002-2v-80a2.006 2.006 0 00-2-2h-118a2.006 2.006 0 00-2 2v27",
    strokeWidth: "3"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: "2",
    d: "M133.721 14h-122M29.721 8h-10"
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: "3",
    d: "M2.121 55.1l19.3-19.2M21.421 55.1l-19.3-19.2"
  }))));
}